import React, { useState } from 'react';
import { Modal } from './ui/Modal';
type ModalType = 'terms' | 'privacy' | null;
export function Footer() {
  const [openModal, setOpenModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-sage-800 text-sage-100/60 py-12 text-center" data-id="element-129">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-130">
          <h3 className="font-serif text-2xl text-cream mb-6" data-id="element-131">
            Vuelve a Sentirte Tú
          </h3>

          <div className="flex flex-wrap justify-center gap-6 text-sm mb-8" data-id="element-132">
            <button onClick={() => setOpenModal('terms')} className="hover:text-cream transition-colors underline-offset-4 hover:underline" data-id="element-133">
              Términos y Condiciones
            </button>
            <button onClick={() => setOpenModal('privacy')} className="hover:text-cream transition-colors underline-offset-4 hover:underline" data-id="element-134">
              Política de Privacidad
            </button>
          </div>

          <p className="text-xs" data-id="element-135">
            &copy; {new Date().getFullYear()} Vuelve a Sentirte Tú. Todos los
            derechos reservados.
          </p>
          <p className="text-xs mt-2 max-w-2xl mx-auto opacity-50" data-id="element-136">
            Este producto no sustituye el consejo médico profesional. Consulte a
            su médico antes de comenzar cualquier programa de nutrición o
            suplementación.
          </p>
        </div>
      </footer>

      {/* Terms Modal */}
      <Modal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Términos y Condiciones" data-id="element-137">
        <p className="text-xs uppercase tracking-widest text-sage-700 font-semibold" data-id="element-138">
          Última actualización: {new Date().getFullYear()}
        </p>

        <h3 className="font-serif text-xl font-semibold text-charcoal mt-4" data-id="element-139">
          1. Aceptación de los Términos
        </h3>
        <p data-id="element-140">
          Al acceder y adquirir el programa{' '}
          <strong data-id="element-141">Vuelve a Sentirte Tú: Menopause Reset</strong>, aceptas estos
          Términos y Condiciones en su totalidad. Si no estás de acuerdo con
          alguna parte, te pedimos no realizar la compra.
        </p>

        <h3 className="font-serif text-xl font-semibold text-charcoal mt-4" data-id="element-142">
          2. Descripción del Producto
        </h3>
        <p data-id="element-143">
          El programa es un producto digital descargable (PDF) compuesto por 15
          módulos educativos y 3 bonos exclusivos, diseñado con fines
          informativos y educativos para mujeres entre 40 y 60 años.
        </p>

        <h3 className="font-serif text-xl font-semibold text-charcoal mt-4" data-id="element-144">
          3. Acceso y Entrega
        </h3>
        <p data-id="element-145">
          Una vez completado el pago, recibirás acceso inmediato al material en
          el correo electrónico proporcionado durante la compra. Es tu
          responsabilidad ingresar un correo válido.
        </p>

        <h3 className="font-serif text-xl font-semibold text-charcoal mt-4" data-id="element-146">
          4. Política de Reembolso
        </h3>
        <p data-id="element-147">
          Ofrecemos una <strong data-id="element-148">Garantía de Riesgo Cero de 30 días</strong>. Si
          dentro de los primeros 30 días posteriores a la compra sientes que el
          programa no es para ti, escríbenos y te reembolsaremos el 100% de tu
          dinero, sin preguntas.
        </p>

        <h3 className="font-serif text-xl font-semibold text-charcoal mt-4" data-id="element-149">
          5. Aviso Médico
        </h3>
        <p data-id="element-150">
          La información contenida en el programa <strong data-id="element-151">no sustituye</strong>{' '}
          el consejo médico profesional. Antes de aplicar cualquier
          recomendación de nutrición, suplementación o estilo de vida, consulta
          con tu médico de confianza.
        </p>

        <h3 className="font-serif text-xl font-semibold text-charcoal mt-4" data-id="element-152">
          6. Propiedad Intelectual
        </h3>
        <p data-id="element-153">
          Todo el contenido del programa está protegido por derechos de autor.
          No está permitida la reproducción, distribución, reventa o cesión del
          material a terceros sin autorización expresa.
        </p>

        <h3 className="font-serif text-xl font-semibold text-charcoal mt-4" data-id="element-154">
          7. Limitación de Responsabilidad
        </h3>
        <p data-id="element-155">
          Los resultados individuales pueden variar. No garantizamos resultados
          específicos en salud, peso o bienestar, ya que dependen del compromiso
          y las condiciones particulares de cada persona.
        </p>
      </Modal>

      {/* Privacy Modal */}
      <Modal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Política de Privacidad" data-id="element-156">
        <p className="text-xs uppercase tracking-widest text-sage-700 font-semibold" data-id="element-157">
          Última actualización: {new Date().getFullYear()}
        </p>

        <h3 className="font-serif text-xl font-semibold text-charcoal mt-4" data-id="element-158">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-159">
          Recopilamos información que tú proporcionas voluntariamente al
          realizar una compra: nombre, correo electrónico y datos de facturación
          necesarios para procesar el pago a través de nuestra plataforma
          segura.
        </p>

        <h3 className="font-serif text-xl font-semibold text-charcoal mt-4" data-id="element-160">
          2. Cómo Usamos tu Información
        </h3>
        <p data-id="element-161">Utilizamos tus datos exclusivamente para:</p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-162">
          <li data-id="element-163">Procesar tu pago y entregar el producto digital.</li>
          <li data-id="element-164">Enviarte el acceso al programa y comunicaciones relacionadas.</li>
          <li data-id="element-165">Brindarte soporte si lo necesitas.</li>
          <li data-id="element-166">Mejorar tu experiencia con contenido relevante (opcional).</li>
        </ul>

        <h3 className="font-serif text-xl font-semibold text-charcoal mt-4" data-id="element-167">
          3. Compartir Información con Terceros
        </h3>
        <p data-id="element-168">
          No vendemos, alquilamos ni cedemos tu información personal a terceros.
          Únicamente compartimos los datos estrictamente necesarios con nuestros
          proveedores de pago (Shopify) y plataformas de envío de correo, todos
          bajo políticas estrictas de privacidad.
        </p>

        <h3 className="font-serif text-xl font-semibold text-charcoal mt-4" data-id="element-169">
          4. Cookies y Análisis
        </h3>
        <p data-id="element-170">
          Utilizamos cookies y herramientas de análisis (incluyendo Meta Pixel)
          para entender cómo los visitantes interactúan con nuestra página,
          mejorar la experiencia y mostrar publicidad relevante. Puedes
          desactivar las cookies desde la configuración de tu navegador.
        </p>

        <h3 className="font-serif text-xl font-semibold text-charcoal mt-4" data-id="element-171">
          5. Seguridad
        </h3>
        <p data-id="element-172">
          Todos los pagos se procesan a través de una pasarela segura y
          encriptada. No almacenamos información de tarjetas de crédito en
          nuestros servidores.
        </p>

        <h3 className="font-serif text-xl font-semibold text-charcoal mt-4" data-id="element-173">
          6. Tus Derechos
        </h3>
        <p data-id="element-174">
          Tienes derecho a acceder, rectificar o eliminar tus datos personales
          en cualquier momento. Para ejercer estos derechos, contáctanos
          respondiendo al correo de confirmación de tu compra.
        </p>

        <h3 className="font-serif text-xl font-semibold text-charcoal mt-4" data-id="element-175">
          7. Cambios en esta Política
        </h3>
        <p data-id="element-176">
          Nos reservamos el derecho de actualizar esta política. Te recomendamos
          revisarla periódicamente. Los cambios entrarán en vigor desde el
          momento de su publicación.
        </p>
      </Modal>
    </>;
}